import { DotsProps } from "./props";
import styles from "./dots.module.scss";

export default function Dots({ invert }: DotsProps) {
  return (
    <svg
      className={`${styles.content} ${
        invert ? styles["content--invert"] : ""
      } `}
      viewBox="0 0 91 91"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <g fillRule="nonzero">
          <g>
            <g>
              <circle cx="3.261" cy="3.445" r="2.72" />
              <circle cx="15.296" cy="3.445" r="2.719" />
              <circle cx="27.333" cy="3.445" r="2.72" />
              <circle cx="39.369" cy="3.445" r="2.72" />
              <circle cx="51.405" cy="3.445" r="2.72" />
              <circle cx="63.441" cy="3.445" r="2.72" />
              <circle cx="75.479" cy="3.445" r="2.72" />
              <circle cx="87.514" cy="3.445" r="2.719" />
            </g>
            <g transform="translate(0 12)">
              <circle cx="3.261" cy="3.525" r="2.72" />
              <circle cx="15.296" cy="3.525" r="2.719" />
              <circle cx="27.333" cy="3.525" r="2.72" />
              <circle cx="39.369" cy="3.525" r="2.72" />
              <circle cx="51.405" cy="3.525" r="2.72" />
              <circle cx="63.441" cy="3.525" r="2.72" />
              <circle cx="75.479" cy="3.525" r="2.72" />
              <circle cx="87.514" cy="3.525" r="2.719" />
            </g>
            <g transform="translate(0 24)">
              <circle cx="3.261" cy="3.605" r="2.72" />
              <circle cx="15.296" cy="3.605" r="2.719" />
              <circle cx="27.333" cy="3.605" r="2.72" />
              <circle cx="39.369" cy="3.605" r="2.72" />
              <circle cx="51.405" cy="3.605" r="2.72" />
              <circle cx="63.441" cy="3.605" r="2.72" />
              <circle cx="75.479" cy="3.605" r="2.72" />
              <circle cx="87.514" cy="3.605" r="2.719" />
            </g>
            <g transform="translate(0 36)">
              <circle cx="3.261" cy="3.686" r="2.72" />
              <circle cx="15.296" cy="3.686" r="2.719" />
              <circle cx="27.333" cy="3.686" r="2.72" />
              <circle cx="39.369" cy="3.686" r="2.72" />
              <circle cx="51.405" cy="3.686" r="2.72" />
              <circle cx="63.441" cy="3.686" r="2.72" />
              <circle cx="75.479" cy="3.686" r="2.72" />
              <circle cx="87.514" cy="3.686" r="2.719" />
            </g>
            <g transform="translate(0 49)">
              <circle cx="3.261" cy="2.767" r="2.72" />
              <circle cx="15.296" cy="2.767" r="2.719" />
              <circle cx="27.333" cy="2.767" r="2.72" />
              <circle cx="39.369" cy="2.767" r="2.72" />
              <circle cx="51.405" cy="2.767" r="2.72" />
              <circle cx="63.441" cy="2.767" r="2.72" />
              <circle cx="75.479" cy="2.767" r="2.72" />
              <circle cx="87.514" cy="2.767" r="2.719" />
            </g>
            <g transform="translate(0 61)">
              <circle cx="3.261" cy="2.846" r="2.72" />
              <circle cx="15.296" cy="2.846" r="2.719" />
              <circle cx="27.333" cy="2.846" r="2.72" />
              <circle cx="39.369" cy="2.846" r="2.72" />
              <circle cx="51.405" cy="2.846" r="2.72" />
              <circle cx="63.441" cy="2.846" r="2.72" />
              <circle cx="75.479" cy="2.846" r="2.72" />
              <circle cx="87.514" cy="2.846" r="2.719" />
            </g>
            <g transform="translate(0 73)">
              <circle cx="3.261" cy="2.926" r="2.72" />
              <circle cx="15.296" cy="2.926" r="2.719" />
              <circle cx="27.333" cy="2.926" r="2.72" />
              <circle cx="39.369" cy="2.926" r="2.72" />
              <circle cx="51.405" cy="2.926" r="2.72" />
              <circle cx="63.441" cy="2.926" r="2.72" />
              <circle cx="75.479" cy="2.926" r="2.72" />
              <circle cx="87.514" cy="2.926" r="2.719" />
            </g>
            <g transform="translate(0 85)">
              <circle cx="3.261" cy="3.006" r="2.72" />
              <circle cx="15.296" cy="3.006" r="2.719" />
              <circle cx="27.333" cy="3.006" r="2.72" />
              <circle cx="39.369" cy="3.006" r="2.72" />
              <circle cx="51.405" cy="3.006" r="2.72" />
              <circle cx="63.441" cy="3.006" r="2.72" />
              <circle cx="75.479" cy="3.006" r="2.72" />
              <circle cx="87.514" cy="3.006" r="2.719" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
